import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CALENDARIO_ESPANOL } from '../core/_util/fechas';
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';

@Component({
  selector: 'app-crear-requerimiento-cargo-cliente',
  templateUrl: './crear-requerimiento-cargo-cliente.component.html',
  styleUrls: ['./crear-requerimiento-cargo-cliente.component.scss'],
})
export class CrearRequerimientoCargoClienteComponent implements OnInit {

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  submitted: Boolean = false;
  
  //lista de registros
  registrosLista: any = [];
  listaCiudad: any[] = [];
  listaCargo: any[] = [];
  listaCargosCliente: any[] = [];
  crear: any = '';

  espanol: any;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService,
    private route: ActivatedRoute,
  ) {
    this.breadCrumbService.setItems([
      { label: 'Crear Solicitud Cliente' }
    ]);

    this.formBuilder = new FormBuilder();
  }

  ngOnInit(): void {
    if(this.route.snapshot){
      this.crear = this.route.snapshot;
  }    
    this.espanol = CALENDARIO_ESPANOL;
    this.formulario = this.formBuilder.group({
      ciudad: ['', Validators.required],
      cargo: ['', Validators.required],
      salario: ['', Validators.required],
      vacantes: ['', Validators.required],
      fechaSolicitud: ['', Validators.required],
      fechaTentativa: [''],
      observacion: ['']
    });

    this.getListaCargo();    
  }

  /**
   * Listados
   */
  getListaCiudad(e)
  {
    let params = {texto: e.query}
    if(e.query.length > 2)
    {
      this.coreService.getWithParams('/lugares', params).subscribe(
        (res: any) => {
          this.listaCiudad = res;  

        },
        (err: any) => {
            console.log(err);
        }
        )
    }
  }

  getListaCargo() {
    this.coreService.get('/listar-cargos-cliente').subscribe(
      (res: any[]) => {
        this.listaCargo = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  getFechaTentativa() {
    const formato = 'yyyy-MM-dd';
    const localizacion = 'en-US';
    if(this.formulario.value.vacantes != null && this.formulario.value.vacantes != "" && this.formulario.value.vacantes != undefined &&
      this.formulario.value.fechaSolicitud != null && this.formulario.value.fechaSolicitud != "" && this.formulario.value.fechaSolicitud != undefined){
        this.spinner.show();
        let params = {
          vacantes: this.formulario.value.vacantes,
          ficha_id: 6748, //this.formulario.value.cargo.ficha_id
          fechaSolicitud: this.formulario.value.fechaSolicitud          
        }
        params.fechaSolicitud = formatDate(this.formulario.value['fechaSolicitud'], formato, localizacion);
        this.coreService.post('/fecha-tentativa', params).subscribe(
          (res: any) => {
            this.formulario.controls['fechaTentativa'].setValue(formatDate(res.fecha[0]['fecha_estimada'], formato, localizacion));
            this.spinner.hide();
          },
          (err: any) => {
            console.log(err);
            this.spinner.hide();
          }
        )
    }
  }

  /**
   * Crear
   */
  guardar() {
    var dat = this.formulario.valid;
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar este requerimiento?',
        accept: () => {
          this.submitted = true;
          this.postGuardarReq();
        }
      });
    }else{
      this.formulario.markAllAsTouched();
    }
  }

  postGuardarReq() {
    const formato = 'yyyy-MM-dd';
    const localizacion = 'en-US';

    let params = {
      ficha_id: this.formulario.value.cargo.ficha_id,
      salario: this.formulario.value.salario,
      num_vacantes: this.formulario.value.vacantes,
      fecha_estimada: this.formulario.value.fechaTentativa,
      cargo_id: this.formulario.value.cargo.id, 
      pais_id: this.formulario.value.ciudad.cod_pais,
      depto_id: this.formulario.value.ciudad.cod_departamento,
      ciudad_id: this.formulario.value.ciudad.cod_ciudad,
      observacion: this.formulario.value.observacion    
    }
    this.coreService.post('/guardar-requerimiento-cliente', params).subscribe(
      (res: any[]) => {
        this.msj.info('Requerimiento Creado Correctamente');
        this.formulario.reset();
      },
      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }

  /**
   * Validaciones
   */  
  campoNoValido(campo: any) {
    return this.formulario.get(campo)?.invalid && this.formulario.get(campo)?.touched;
  }

  pasarAMayusculas(campo) {
    if (this.formulario.value !== null) {
      this.formulario.controls[campo].setValue(this.formulario.value[campo].toUpperCase());
    }
  }

  soloNumerosDecimales(e) {
    if (e.code !== 'Tab') {
      const tecla = (document.all) ? e.keyCode : e.which; // 2
      if (tecla === 8) return true; // 3
      let patron = /[\d.]/; // 4
      const te = String.fromCharCode(tecla); // 5
      return patron.test(te); // 6
    }
  }
}
